import { render, staticRenderFns } from "./Durations.vue?vue&type=template&id=4e301235"
import script from "./Durations.vue?vue&type=script&lang=js"
export * from "./Durations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports